import React from 'react';
import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';
import { SidebarLayout } from 'layouts/Sidebar/SidebarLayout';
import { SolicitudUnica } from './SolicitudIndividual/SolicitudIndividual';
import { SolicitudGrupal } from './SolicitudGrupal/SolicitudGrupal';
import { InvitarNegocioARegistro } from './InvitarNegocioARegistro/InvitarNegocioARegistro';

export const SolicitarAdministracion = () => {
  return (
    <SidebarLayout>
      <div className="mb-5">
        <Heading type="h2">
          Solicitudes de administración a otros negocios
        </Heading>
        <Text>
          Envia solicitudes para administrar otros negocios incluso si no están
          registrados en la plataforma
        </Text>
      </div>
      <SolicitudUnica />
      <SolicitudGrupal />
      <InvitarNegocioARegistro />
    </SidebarLayout>
  );
};
